import LParentView from './LParentView'
let ParentView = LParentView
export {LParentView, ParentView}
